module.exports = __webpack_public_path__ + "static/media/hero-image-2.f2085e36.png";